import React from 'react';

interface TextFieldProps {
  id: string;
  type: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  onClick?: () => void; // Add this new prop
}

const TextField: React.FC<TextFieldProps> = ({
  id,
  type,
  value,
  onChange,
  placeholder,
  disabled,
  maxLength,
  onClick, // Add this new prop
}) => (
  <input
    type={type}
    id={id}
    value={value}
    onChange={onChange}
    onClick={onClick} // Add the onClick handler
    placeholder={placeholder}
    maxLength={maxLength}
    className="cg-input"
    disabled={disabled}
  />
);

export default TextField;
